import {
  TEAM_ACTIVE_USER_OR_DEACTIVATE,
  TEAMS_BLOCKED,
  TEAMS_CREATE,
  TEAMS_GET,
  TEAMS_GET_ALL,
  TEAMS_UPDATE
} from '../types/actions.types';
import Admin from '../../api/methods/Admin';
import helper from '../../service/helper';
import { SET_ALL } from '../types/mutations.types';
import Teams from '../../api/methods/Teams';

const state = {
  teamsList: [],
  pagination: {},
  utc: [
    { id: -12, name: 'UTC−12:00', city: 'Baker Island' },
    { id: -11, name: 'UTC−11:00', city: 'Pago Pago' },
    { id: -10, name: 'UTC−10:00', city: 'Honolulu' },
    { id: -9, name: 'UTC−09:00', city: 'Anchorage' },
    { id: -8, name: 'UTC−08:00', city: 'Los Angeles' },
    { id: -7, name: 'UTC−07:00', city: 'Denver' },
    { id: -6, name: 'UTC−06:00', city: 'Chicago' },
    { id: -5, name: 'UTC−05:00', city: 'New York' },
    { id: -4, name: 'UTC−04:00', city: 'Santiago' },
    { id: -3, name: 'UTC−03:00', city: 'Buenos Aires' },
    { id: -2, name: 'UTC−02:00', city: 'South Georgia' },
    { id: -1, name: 'UTC−01:00', city: 'Azores' },
    { id: 0, name: 'UTC±00:00', city: 'London' },
    { id: 1, name: 'UTC+01:00', city: 'Berlin' },
    { id: 2, name: 'UTC+02:00', city: 'Athens' },
    { id: 3, name: 'UTC+03:00', city: 'Moscow' },
    { id: 4, name: 'UTC+04:00', city: 'Dubai' },
    { id: 5, name: 'UTC+05:00', city: 'Tashkent' },
    { id: 6, name: 'UTC+06:00', city: 'Dhaka' },
    { id: 7, name: 'UTC+07:00', city: 'Bangkok' },
    { id: 8, name: 'UTC+08:00', city: 'Beijing' },
    { id: 9, name: 'UTC+09:00', city: 'Tokyo' },
    { id: 10, name: 'UTC+10:00', city: 'Sydney' },
    { id: 11, name: 'UTC+11:00', city: 'Solomon Islands' },
    { id: 12, name: 'UTC+12:00', city: 'Auckland' },
    { id: 13, name: 'UTC+13:00', city: 'Nukuʻalofa' },
    { id: 14, name: 'UTC+14:00', city: 'Kiritimati' }
  ]

};

const getters = {
  teamsList (state) {
    return state.teamsList.map((item) => {
      item.actions = false;
      return item;
    });
  }
};

const actions = {
  async [TEAMS_GET_ALL] (vuex, { context, params } = {}) {
    try {
      const data = await Teams.getAll(helper.clearObject(params));
      return Promise.resolve(data);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },
  async [TEAMS_GET] (vuex, { context, params = {} } = {}) {
    try {
      const { payload } = await Teams.get(params.id);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },
  async [TEAMS_UPDATE] (vuex, { context, teamId, params = {} } = {}) {
    try {
      const { payload } = await Admin.updateTeam(teamId, helper.clearObject(params));
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },
  async [TEAMS_CREATE] (vuex, { context, params = {} } = {}) {
    try {
      const { payload, success } = await Admin.createTeam(helper.clearObject(params));

      if (success) {
        context.$Notify({
          title: 'Team',
          message: 'Successfully created',
          type: 'success'
        });
      }

      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },
  async [TEAMS_BLOCKED] (vuex, { context, teamId, is_blocked: isBlocked } = {}) {
    try {
      const { payload } = await Admin.updateTeam(teamId, {
        is_active: isBlocked
      });
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },
  async [TEAM_ACTIVE_USER_OR_DEACTIVATE] (vuex, { teamId, operatorId } = {}) {
    try {
      const { payload } = await Teams.activeOperatorInTeam(teamId, operatorId);
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }
};

const mutations = {
  [SET_ALL] (state, { data, key }) {
    state[key] = data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
